module.exports = __webpack_public_path__ + "static/media/PaymentOptinScreen.5ac4f97b.png";